import FooterSubscription from '../page-components/Subscription/Subscription';

export default FooterSubscription;
